export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 5.75A1.25 1.25 0 0010.75 7v3a.75.75 0 01-1.5 0V7c0-.075.003-.15.009-.223A1.25 1.25 0 007.75 8v4a.75.75 0 01-1.5 0V9.775A1.25 1.25 0 004.75 11v.5a6.75 6.75 0 006.75 6.75H15A4.25 4.25 0 0019.25 14V9a1.25 1.25 0 10-2.5 0v2a.75.75 0 01-1.5 0V9c0-.7.262-1.338.691-1.823a1.248 1.248 0 00-1.636-.216A1.248 1.248 0 0013.75 8v2a.75.75 0 01-1.5 0V8c0-.7.262-1.338.691-1.823A1.248 1.248 0 0012 5.75zm2.211-.385A2.745 2.745 0 0012 4.25c-.907 0-1.71.439-2.211 1.115A2.75 2.75 0 006.25 8v.261a2.75 2.75 0 00-3 2.739v.5a8.25 8.25 0 008.25 8.25H15A5.75 5.75 0 0020.75 14V9a2.75 2.75 0 00-3.539-2.635 2.745 2.745 0 00-3-1z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};